import { render, staticRenderFns } from "./additional-data.vue?vue&type=template&id=6c330a6a&scoped=true"
import script from "./additional-data.vue?vue&type=script&lang=js"
export * from "./additional-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c330a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c330a6a')) {
      api.createRecord('6c330a6a', component.options)
    } else {
      api.reload('6c330a6a', component.options)
    }
    module.hot.accept("./additional-data.vue?vue&type=template&id=6c330a6a&scoped=true", function () {
      api.rerender('6c330a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/events/additional-data.vue"
export default component.exports